export const ScheduleLayout = {
    CARD_WIDTH: '280px',
    TIMELINE_COLUMN_WIDTH: '40px',
    BACKGROUND_LEFT_OFFSET: '320px', // 280px card + 40px timeline width
    HEADER_HEIGHT: '32px',
    HEADER_BAR_HEIGHT: '22px',
    ROW_HEIGHT: '126px',
    ROW_BAR_HEIGHT: '116px',
    ROW_GAP: '8px',
    PRODUCT_COLUMN_SPACER: '8px',
    PRODUCT_COLUMN_SPACER_START: '16px',
    PRODUCT_COLUMN_SPACER_END: '20px',
    PRODUCT_COLUMN_WIDTH: '288px', // 8px spacer + 280px card
    PRODUCT_COLUMN_WIDTH_FIRST: '296px', // 16px spacer + 280px card
    PRODUCT_COLUMN_WIDTH_LAST: '308px', // 8px spacer + 280px card + 20px end spacer
} as const;
